/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { AuthGuard } from './guard/auth.guard';
import { SuperAdminGuard } from './guard/super-admin.guard';
import { WriteAccessGuard } from './guard/write-access.guard';
import { UnauthorizedAccessInterceptor } from './interceptor/unauthorized-access.interceptor';
import { LoginComponent } from './login/login.component';

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    SharedModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.backendServer + '/api'],
        sendAccessToken: true
      }
    })
  ],
  providers: [
    AuthGuard,
    WriteAccessGuard,
    SuperAdminGuard,
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedAccessInterceptor, multi: true },
    { provide: OAuthStorage, useFactory: () => localStorage }
  ]
})
export class AuthModule {
  constructor(private oauthService: OAuthService) {
    this.oauthService.tokenEndpoint = environment.backendServer + '/token';
    this.oauthService.clientId = environment.oAuthClientId;
    this.oauthService.dummyClientSecret = environment.oAuthClientSecret;
    this.oauthService.requireHttps = environment.production;
    this.oauthService.scope = '';
    this.oauthService.userinfoEndpoint = environment.backendServer + '/api/me';
    this.oauthService.oidc = false;
    this.oauthService.events.pipe(
      filter(e => e.type === 'token_expires')
    ).subscribe(() => {
      this.oauthService.refreshToken().then();
    });
  }
}
